export const WINELIDAYS_LS_PREFIX = 'wld';
